import { useAuthContext } from './AuthContext';

interface PermissionGateProps {
    required: string;
    children: React.ReactNode;
}

export const PermissionGate = ({ required, children }: PermissionGateProps) => {
    const { permissions } = useAuthContext();

    if (!permissions.includes(required)) return null;
    return <>{children}</>;
};